import {
    MutationCache,
    QueryCache,
    QueryClient,
    keepPreviousData,
    notifyManager,
} from '@tanstack/react-query';
import { startTransition } from 'react';
import * as Sentry from '@sentry/react';
import { isEnabled } from '@/lib/sentry/sentry';

notifyManager.setScheduler(startTransition);

function addQueryErrorBreadcrumb(category: 'query' | 'mutation', key: unknown) {
    if (!isEnabled()) return;
    Sentry.addBreadcrumb({
        category,
        message: key ? JSON.stringify(key) : `unnamed ${category}`,
        level: 'warning',
    });
}

export const queryClient = new QueryClient({
    queryCache: new QueryCache({
        onError: (_error, query) => addQueryErrorBreadcrumb('query', query.queryKey),
    }),
    mutationCache: new MutationCache({
        onError: (_error, _variables, _context, mutation) =>
            addQueryErrorBreadcrumb('mutation', mutation.options.mutationKey),
    }),
    defaultOptions: {
        queries: {
            gcTime: 60 * 60 * 1000,
            staleTime: 60_000,
            refetchOnWindowFocus: false,
            refetchOnReconnect: false,
            retry: 1,
            placeholderData: keepPreviousData,
            structuralSharing: true,
        },
    },
});

declare global {
    interface Window {
        __TANSTACK_QUERY_CLIENT__: import('@tanstack/query-core').QueryClient;
    }
}

window.__TANSTACK_QUERY_CLIENT__ = queryClient;
